import React, { useState, useEffect } from "react";
import { APP_STORE_URL, PLAY_STORE_URL } from "../utils/constants";

const DISMISS_KEY = "appBannerDismissedAt";
// How long the banner stays hidden after it is closed (same as the coupon)
const SNOOZE_MS = 10 * 60 * 1000;

// Time left before a dismissed banner shows again (0 when it should be visible)
const snoozeRemaining = () => {
  try {
    const dismissedAt = Number(localStorage.getItem(DISMISS_KEY));
    return dismissedAt ? Math.max(0, dismissedAt + SNOOZE_MS - Date.now()) : 0;
  } catch {
    return 0;
  }
};

const MobileBanner = () => {
  const [storeLink, setStoreLink] = useState(null);
  const [hidden, setHidden] = useState(() => snoozeRemaining() > 0);

  // Bring the banner back once the snooze runs out, even if the page stays open
  useEffect(() => {
    if (!hidden) return;
    // Falls back to a full snooze when storage is unavailable
    const timer = setTimeout(() => setHidden(false), snoozeRemaining() || SNOOZE_MS);
    return () => clearTimeout(timer);
  }, [hidden]);

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;

    if (isAndroid) {
      setStoreLink(PLAY_STORE_URL);
    } else if (isIOS) {
      setStoreLink(APP_STORE_URL);
    }
  }, []);

  const handleRedirect = () => {
    if (storeLink) {
      window.location.href = storeLink;
    }
  };

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {}
    setHidden(true);
  };

  if (!storeLink || hidden) return null;

  return (
    <div className="mobile-banner app-banner d-lg-none">
      <div className="container container-lg d-flex align-items-center justify-content-between gap-12 py-8">
        <span className="d-flex align-items-center gap-8 text-sm fw-semibold text-gray-900">
          <i className="bi bi-phone text-main-600 text-xl" aria-hidden="true"></i>
          Shop faster on the Bigmall app
        </span>
        <div className="d-flex align-items-center gap-8">
        <button
          type="button"
          className="app-banner__button btn bg-main-600 text-white rounded-pill py-6 px-16 text-sm fw-semibold"
          onClick={handleRedirect}
        >
          Get app
        </button>
        <button type="button" className="app-banner__close" onClick={dismiss} aria-label="Close app banner">
          <i className="ph ph-x" aria-hidden="true" />
        </button>
        </div>
      </div>
    </div>
  );
};

export default MobileBanner;
